'use client';

import { FC, PropsWithChildren, useEffect, useRef } from 'react';

import { FlagExperiment } from 'src/data/FlagsApi/FlagsApi.type';

import { useABTestEvent } from '../../../general/components/ABTest/useABTestEvent';

interface Props {
  experiment: FlagExperiment;
}

export const ResultsGridABTestEventWrapper: FC<PropsWithChildren<Props>> = ({ children, experiment }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { triggerEvent } = useABTestEvent(experiment, 'conversion_0', {
    enabled: false,
  });

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const handleClick = (event: Event) => {
      const target = event.target as HTMLElement;
      if (target.closest('.Card-link') && experiment) {
        triggerEvent();
      }
    };

    if (wrapper) {
      wrapper.addEventListener('click', handleClick);
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('click', handleClick);
      }
    };
  });

  return (
    <div ref={wrapperRef} className="h-full">
      {children}
    </div>
  );
};
